import React from 'react'

import { makeStyles, TextField } from '@material-ui/core'

import PropTypes from 'prop-types'

import { defaultB, defaultD, negativeC } from 'asterX-UIkit/constants/colors'
import { PRIMARY_COLORS } from 'asterX-UIkit/colors.constant'

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid #DCE6F3',
    borderRadius: 10,
    backgroundColor: defaultB,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontSize: 16,
    '&:hover': {
      backgroundColor: defaultB
    },
    '&$focused': {
      backgroundColor: defaultB,
      border: `1px solid ${PRIMARY_COLORS[300]}`,
      boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF'
    },
    '&$error': {
      backgroundColor: defaultB,
      borderColor: negativeC
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  focused: {},
  error: {},
  inputLabel: {
    color: defaultD,
    fontWeight: 400,
    fontSize: 16,
    paddingLeft: 2,
    '&.MuiInputLabel-shrink': {
      color: defaultD,
      fontWeight: 400,
      fontSize: 12
    },
    '&.focused': {
      color: defaultD,
      fontWeight: 400,
      fontSize: 12
    }
  }
}))

const AsterTextField = ({ InputProps, ...props }) => {
  const classes = useStyles()
  const { label } = props

  return (
    <TextField
      label={label}
      InputLabelProps={{
        classes: {
          root: classes.inputLabel,
          focused: 'focused'
        }
      }}
      InputProps={{
        classes: {
          root: classes.root,
          error: classes.error,
          focused: classes.focused
        },
        disableUnderline: true,
        ...InputProps
      }}
      {...props}
      variant="filled"
    />
  )
}

export default AsterTextField

AsterTextField.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  InputProps: PropTypes.object,
  InputLabelProps: PropTypes.object,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.string,
  id: PropTypes.string,
  fullWidth: PropTypes.bool
}
